import classNames from "classnames";
import PropTypes from "prop-types";
import { buttonLinkPropTypes } from "utils/types";

const Button = ({ button, appearance, handleClick, size }) => {
  return (
    <button
      onClick={handleClick}
      className={classNames(
        "text-center text-lg md:text-base rounded-full border border-2 border-onmoPrimary h-[55px] md:h-[52px] font-medium",
        {
          "bg-onmoPrimary text-white": appearance === "primary",
        },
        {
          "text-onmoPrimary bg-transparent": appearance === "secondary",
        },
        {
          "text-onmoPrimary bg-transparent": appearance === "disabled",
        },
        {
          "text-white bg-onmoGreen border-onmoGreen bg-transparent":
            appearance === "alternative",
        },
        {
          "w-full md:w-[200px]": size === "large",
        },
        {
          "w-full md:w-[188px]": size === "medium",
        },
        {
          "w-full md:w-[170px]": size === "small",
        },
      )}
    >
      {button?.text}
    </button>
  );
};

Button.propTypes = {
  button: buttonLinkPropTypes,
  appearance: PropTypes.oneOf([
    "primary",
    "secondary",
    "alternative",
    "disabled",
  ]),
  size: PropTypes.oneOf(["large", "medium", "small"]),
  compact: PropTypes.bool,
};

export default Button;
